import React, { FC } from "react";

import { Stack, SxProps } from "@mui/material";

interface Props {
  children: any;
  stackMargin?: boolean;
  sx?: SxProps;
}

const StackContent: FC<Props> = ({ children, stackMargin = true, sx = {} }) => {
  return (
    <Stack
      sx={{
        width: "100%",
        maxWidth: "1080px",
        margin: stackMargin === false ? "0px auto 0px" : "40px auto 0",
        padding: { xs: "0 24px", lg: "0" },
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};

export default StackContent;
